import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { formatCommas } from 'components/project/ClerkScreen/shared/utils/common';
import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';
import { breakpoints } from '../../../../shared/utils/styles';

const getColorsCss = ({ variants }) => css`
  background-color: ${variants.backgroundColor};
  & h1 {
    color: ${variants.color}
  }
`;

const Container = styled(motion.div)`
  grid-area: amount;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  ${(props) => getColorsCss(props)};
  & h1 {
    white-space: nowrap;
    margin: 0;
    font-size: min(14vw, 16em);
    @media (max-width: ${breakpoints.auctioneer.small}) {
      font-size: min(10vw, 12em);
    }
  }
`;

const getVariants = () => ({
  default: {
    transition: { delay: 0.1 },
    backgroundColor: '#000',
    color: '#fff',
  },
  flash: {
    transition: { duration: '1.25' },
    backgroundColor: '#fff',
    color: '#000',
  },
});

const HighBidContainer = observer(() => {
  const {
    BidStore: { auction },
  } = useStores();

  const { currentBid } = auction;

  const formattedCurrency = currentBid > 0 ? formatCommas(currentBid) : '';
  return (
    <Container
      key={formattedCurrency}
      initial="flash"
      animate="default"
      exit="flash"
      variants={getVariants()}
    >
      <h1>{formattedCurrency}</h1>
    </Container>
  );
});

export default HighBidContainer;
